import { render, staticRenderFns } from "./RevisionSolicitud.html?vue&type=template&id=b82c4542&external"
import script from "./RevisionSolicitud.vue?vue&type=script&lang=js"
export * from "./RevisionSolicitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports